import { useRouteLoaderData } from '@remix-run/react'
import { useRootData } from '#app/context/root-data'
import { type IUserRole } from '#app/models/user-role._._definitions.js'
import { type IUser } from '#app/models/user._._definitions.ts'
import { type loader as rootLoader } from '#app/root.tsx'

// function isUser(user: any): user is SerializeFrom<typeof rootLoader>['user'] {
// 	return user && typeof user === 'object' && typeof user.id === 'string'
// }

export function useOptionalUser() {
	const data = useRouteLoaderData<typeof rootLoader>('root')
	if (!data || !data.user) {
		return undefined
	}
	return data.user
}

export function useUser() {
	const maybeUser = useOptionalUser()
	const { data } = useRootData()
	
	if (maybeUser) return maybeUser

	if (data?.user) return data.user

	throw new Error(
			'No user found in root loader, but user is required by useUser. If user is optional, try useOptionalUser instead.',
	)
}

type Action = 'create' | 'read' | 'update' | 'delete'
type Entity = 'user' | 'note'
type Access = 'own' | 'any' | 'own,any' | 'any,own'
export type PermissionString =
	| `${Action}:${Entity}`
	| `${Action}:${Entity}:${Access}`

export function parsePermissionString(permissionString: PermissionString) {
	const [action, entity, access] = permissionString.split(':') as [
		Action,
		Entity,
		Access | undefined,
	]
	return {
		action,
		entity,
		access: access ? (access.split(',') as Array<Access>) : undefined,
	}
}

export function userHasPermission(
	user: Pick<ReturnType<typeof useUser>, 'roles'> | IUser | null | undefined,
	permission: PermissionString,
) {
	if (!user || !user.roles) return false
	const { action, entity, access } = parsePermissionString(permission)
	const roles = user.roles as IUserRole[]
	return roles.some((userRole) =>
		userRole.role?.permissions?.some(
			(permission) =>
				permission.entity === entity &&
				permission.action === action &&
				(!access || access.includes(permission.access)),
		),
	)
}

export function getUserInitials(name: string): string {
	return name
		.split(' ')
		.map((n) => n[0])
		.join('')
		.toUpperCase()
		.slice(0, 2)
}

// export function userHasRole(
// 	user: Pick<ReturnType<typeof useUser>, 'roles'> | IUser | null,
// 	role: string,
// ) {
// 	if (!user || !user.roles) return false
// 	const roles = user.roles as IUserRole[]
// 	return roles.some((userRole) => userRole.role?.name === role)
// }
